export const currencyWithPrefix = (value: number) => {
    const formattedValue = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);

    return formattedValue;
};

export const concurrencyWithoutPrefix = (value: number) => {
    const formattedValue = currencyWithPrefix(value);
    return formattedValue.replace(/^R\$\s?/, '');
}

export const currencyToNumber = (value: string) => {
    if (!value) return 0;

    const numericString = value.replace(/[^\d,-]/g, '').replace('.', '').replace(/,/g, '.');
    const numberValue = parseFloat(numericString);

    return isNaN(numberValue) ? 0 : numberValue;
}

// Variante para valores em formato americano (vírgula = milhar, ponto = decimal
// - ex: "66,646.75", "994.727640190"), usada quando a corretora exporta a
// planilha nesse formato (ex: XP) em vez do formato brasileiro assumido por
// currencyToNumber acima. Aplicar a função errada silenciosamente infla o
// valor em ~100x pra qualquer número com casas decimais (ex: "12.70" vira
// 1270 via currencyToNumber) - não são intercambiáveis.
export const currencyToNumberUs = (value: string) => {
    if (!value) return 0;

    const numericString = value.replace(/[^\d.-]/g, '');
    const numberValue = parseFloat(numericString);

    return isNaN(numberValue) ? 0 : numberValue;
}

// Variante pra quando o formato (BR ou US) não é conhecido de antemão e pode
// variar linha a linha - caso da Nikos, onde o número exibido depende da
// configuração regional do Excel de quem copiou (mesma "memória de cálculo"
// mostrou "2,000.00" numa amostra e "1.141.000,00" noutra - confirmado
// olhando o number_format real da célula, que é regional-dependente:
// "#,##0.00"). Heurística: o ÚLTIMO separador (`,` ou `.`) encontrado é o
// decimal; o outro, se houver, é milhar e é descartado. Com um separador só,
// assume decimal (não tenta adivinhar milhar sem o outro símbolo como pista).
export const parseAmbiguousDecimal = (value: string): number => {
    if (!value) return 0;

    const trimmed = value.trim();
    const lastComma = trimmed.lastIndexOf(',');
    const lastDot = trimmed.lastIndexOf('.');

    let numericString: string;
    if (lastComma === -1 && lastDot === -1) {
        numericString = trimmed.replace(/[^\d-]/g, '');
    } else if (lastComma > lastDot) {
        // vírgula é o decimal (formato BR) - ponto(s) antes dela são milhar
        numericString = trimmed.replace(/[^\d,-]/g, '').replace(/,/g, '.');
    } else {
        // ponto é o decimal (formato US) - vírgula(s) antes dele são milhar
        numericString = trimmed.replace(/[^\d.-]/g, '');
    }

    const numberValue = parseFloat(numericString);
    return isNaN(numberValue) ? 0 : numberValue;
}